import * as React from 'react';
import './index.scss';
import { StageDefault } from '@pubts/context.ts';
import { fetch, AreaInfo, RankItem } from '@pubts/fetch.ts';
import { None, WebAnchorItem, WithPage, WebAnchorItemDesc } from '@huyafed/comp'
interface Props extends AreaInfo {
  iAreaId: number,
  iSubAreaId: number,
  data: any,
  finalRankBefore: any;
}
const { useState, useEffect, useContext } = React;

const Rank4: React.FC<Props> = props => (
  <div className='rank4'>
    <div className="rank4-top3-main">
      {
        props.finalRankBefore.map((item: any, idx: number) => (
          <div className={`finalBefore finalBefore-${idx}`} key={idx} onClick={(): void => {
            window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank');
          }}>
            <div className="img">
              <img src={item.sLogoUrl} />
            </div>
            <div className="lable"></div>
            <div className="content">
              <b><span> {item.sNickName}</span></b>
              <p>里程 <i className="score">{item.lScore}</i></p>
            </div>
          </div>
        ))
      }
    </div>
    <div className="rank4-list">
      <WebAnchorItemDesc
        width={860}
        color="#f6d94a"
        descs={['排名', '主播昵称', '总里程']}
      />
      <div className='rank-List'>
        {
          props.data.length === 0 ?
            <None text={'暂无数据'} color={'#fff'} />
            :
            props.data.map((item: RankItem, idx: number) => (
              <WebAnchorItem
                width={870}
                canJump={true}
                isLarge={true}
                color={'#ffffff'}
                borderColor={'#efd294'}
                key={idx}
                msg={{ ...item, tJump: { ...item.tJump, bIsLive: item.tJump.iIsLive }, sNickName: item.sNickName, sLogoUrl: item.sLogoUrl }}
              />
            ))
        }
      </div>
      {props.children}
    </div>

  </div>
)
export default WithPage(Rank4);